/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedRecentHistoryTracker_item$ref = any;
export type PdpSharedRecentHistoryTracker_item = {
    readonly contemporaryTrackingString: string;
    readonly firstPhotoWebPath: string | null;
    readonly pdpURL: string | null;
    readonly title: string | null;
    readonly browseUrl: string | null;
    readonly categoryCode: string | null;
    readonly serviceId: string | null;
    readonly categoryPath: string | null;
    readonly seller: {
        readonly serviceId: string | null;
    } | null;
    readonly isComplete: boolean | null;
    readonly isListingListed: boolean | null;
    readonly " $refType": PdpSharedRecentHistoryTracker_item$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "PdpSharedRecentHistoryTracker_item",
        "type": "Item",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "contemporaryTrackingString",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "firstPhotoWebPath",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "size",
                        "value": "small"
                    }
                ],
                "storageKey": "firstPhotoWebPath(size:\"small\")"
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "pdpURL",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "title",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "browseUrl",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "categoryCode",
                "args": null,
                "storageKey": null
            },
            (v0 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "categoryPath",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "seller",
                "storageKey": null,
                "args": null,
                "concreteType": "Seller",
                "plural": false,
                "selections": [
                    (v0 /*: any*/)
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isComplete",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isListingListed",
                "args": null,
                "storageKey": null
            }
        ]
    } as any;
})();
(node as any).hash = '19daaa7357d8d5c1c93c5f0d5189bea2';
export default node;
